import { z } from 'zod';
import { EncryptedContent, EncryptedTranscriptEvent } from './content.js';
export const HISTORY_CIPHERTEXT_MAX_BYTES = 1_500_000;
export const HistoryOpaqueId = z
    .string()
    .regex(/^hist_[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/);
export const EncryptedHistoryMetadata = EncryptedContent.refine((c) => c.context.kind === 'history' &&
    c.context.runId.startsWith('machine:') &&
    c.context.runId.length > 8 &&
    HistoryOpaqueId.safeParse(c.context.objectId).success, 'invalid history metadata context');
export const EncryptedHistoryImport = z
    .strictObject({
    metadata: EncryptedHistoryMetadata,
    events: z.array(EncryptedTranscriptEvent).max(64),
})
    .refine((p) => p.events.every((e, i) => e.context.accountId === p.metadata.context.accountId &&
    e.context.epoch === p.metadata.context.epoch &&
    e.context.runId === p.metadata.context.objectId &&
    e.context.objectId === `${e.context.runId}:${e.context.seq}` &&
    (i === 0 || e.context.seq === p.events[i - 1].context.seq + 1)), 'invalid history event context')
    .refine((p) => new TextEncoder().encode(JSON.stringify(p)).length <= HISTORY_CIPHERTEXT_MAX_BYTES, 'history batch too large');
export const EncryptedHistoryRpcFrame = z.strictObject({
    type: z.literal('rpc'),
    id: z
        .string()
        .min(1)
        .max(128)
        .regex(/^[A-Za-z0-9:_-]+$/),
    method: z.literal('content.history.import'),
    params: EncryptedHistoryImport,
});
export const EncryptedHistoryListRequest = z.strictObject({
    after: HistoryOpaqueId.optional(),
    limit: z.number().int().min(1).max(64).default(32),
});
export const EncryptedHistoryList = z.strictObject({
    items: z.array(EncryptedHistoryMetadata).max(64),
    next: HistoryOpaqueId.optional(),
});
//# sourceMappingURL=encrypted-history.js.map